/*
|----------------------------------------------------------------------------------------------
| NAVIGATION HANDLER: Dynamically attach onclick events to single parent profiles in nav
|----------------------------------------------------------------------------------------------
*/

__gh__webApp.navHandler = {
	"init":function(){

		var thisPage;
		
	    $('#drawer-nav-sections > li').each(function() {
		    var n = $(this).children('.subnav').length;
		    if($(n).length == 0){
				$(this).children('a').addClass('noSubLinks'); // get links that have no sub nav & add class to link
		    }
		});

		$('.noSubLinks').click(function() {
			var target 	= $(this).attr('target'),
				url		= $(this).attr('href');
			
			//Respect target value
			if (target){
				window.open(url,target);
				return;
			}
	      	
	      	window.location.href=url;
		});

		$('#button-nav-toggle, #drawer-fade-screen, #drawer-close').on('click touchstart',function(e) {
			$('#drawer, #drawer-fade-screen').toggleClass('is-visible');
			e.preventDefault();
		});
		
		// GA track event when user clicks on top nav links
	    $('#toprail-nav-left li a').click(function() {
	        var thisPage = ($(this).text());
			$('#toprail-nav-left li a').attr('data-gh-tracker-track-event-object', '{"category":"top-nav","action":"'+thisPage+'","label":"'+window.location.href+'"}');
	    });
		
		// GA track event when user clicks on links in hamburger menu
	    $('#wrapper-drawer ul li a').click(function() {
	        var thisPage = ($(this).text());
			$('#wrapper-drawer ul li a').attr('data-gh-tracker-track-event-object', '{"category":"hamburger-nav","action":"'+thisPage+'","label":"'+window.location.href+'"}');
	    });
	}

};
